/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTutorial: build.query<GetTutorialApiResponse, GetTutorialApiArg>({
      query: (queryArg) => ({
        url: `/tutorial/Tutorial`,
        headers: {},
      }),
    }),
    getTutorialByTutorialId: build.query<
      GetTutorialByTutorialIdApiResponse,
      GetTutorialByTutorialIdApiArg
    >({
      query: (queryArg) => ({
        url: `/tutorial/Tutorial/${queryArg.tutorialId}`,
        headers: {},
      }),
    }),
    postTutorialByTutorialId: build.mutation<
      PostTutorialByTutorialIdApiResponse,
      PostTutorialByTutorialIdApiArg
    >({
      query: (queryArg) => ({
        url: `/tutorial/Tutorial/${queryArg.tutorialId}`,
        method: 'POST',
        headers: {},
      }),
    }),
    deleteTutorialByTutorialId: build.mutation<
      DeleteTutorialByTutorialIdApiResponse,
      DeleteTutorialByTutorialIdApiArg
    >({
      query: (queryArg) => ({
        url: `/tutorial/Tutorial/${queryArg.tutorialId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as tutorial }
export type GetTutorialApiResponse =
  /** status 200 Success */ TutorialStateModel[]
export type GetTutorialApiArg = {}
export type GetTutorialByTutorialIdApiResponse =
  /** status 200 Success */ TutorialStateModel
export type GetTutorialByTutorialIdApiArg = {
  tutorialId: string
}
export type PostTutorialByTutorialIdApiResponse =
  /** status 200 Success */ TutorialStateModel
export type PostTutorialByTutorialIdApiArg = {
  tutorialId: string
}
export type DeleteTutorialByTutorialIdApiResponse = unknown
export type DeleteTutorialByTutorialIdApiArg = {
  /** Id of tutorial */
  tutorialId: string
}
export type TutorialStateModel = {
  /** Id/Name of the tutorial */
  tutorialId?: string | null
  /** Id of the user */
  nameId?: string | null
  /** Date/time when the tutorial was completed by the user */
  completedDate?: string | null
}
export type BblErrorModel = {
  /** What went wrong */
  message?: string | null
  /** Stacktrace */
  stackTrace?: string | null
}
export const {
  useGetTutorialQuery,
  useGetTutorialByTutorialIdQuery,
  usePostTutorialByTutorialIdMutation,
  useDeleteTutorialByTutorialIdMutation,
} = injectedRtkApi
